<template>
    <Link
        :href="result.href"
        aria-selected="false"
        class="w-full max-w-full flex   select-none rounded-xl p-3 hover:bg-gray-100" data-headlessui-state=""
        role="option" tabindex="-1">
        <div class="flex h-10 w-10 flex-none items-center justify-center rounded-lg">
            <img :src="result.image" class="w-10 h-10 object-contain">
        </div>
        <div class="ml-4 flex-auto max-w-full min-w-0 ">
            <div class="flex items-center text-sm font-medium text-gray-700 mb-1">
                <div class="pr-1">
                    {{ result.name }}
                </div>
            </div>
            <div class="flex items-center space-x-1 text-sm text-gray-500 truncate min-w-0">
                <div>
                    {{ result.round }}
                </div>
            </div>

        </div>
    </Link>
</template>
<script>
import {Link} from '@inertiajs/vue3';
import ReadonlyRating from '@/Components/Legacy/ReadonlyRating.vue';
import {CheckBadgeIcon} from '@heroicons/vue/24/solid/esm/index.js';

export default {
    components: {
        Link,
        ReadonlyRating,
        CheckBadgeIcon
    },

    props: {
        result: {
            type: Object,
            required: true,
        }
    }
};
</script>
